import { ConfigStateService } from '@medlogic/shared/state-config';
import { EnActivityType, EnMessageSeverity, IMessage } from '@medlogic/shared/gecore';
import { UnsubscribeOnDestroyAdapter, IAtividadeComponenteDAL, ConfigJsonService, MsgPtBR, GlobalService, LogService, EnTheme } from '@medlogic/shared/shared-interfaces';
import { NavigationService } from '../../../shared/service/navigation.service';
import { LibService } from '../../../shared/service/lib.service';
import { FormGroup } from '@angular/forms';
import { IBubble } from '../../../shared/interface/ibubble';
import { CalculatorService } from '../../../shared/service/calculator.service';
import { DadoDAL } from '../../../shared/model/dal/dado-dal';
import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { EnBubbleEvent } from '../../../shared/enum/en-bubble-event.enum';
import { IAtividade } from '../../../shared/interface/iatividade';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

// Barra de botões da Atividade.
@Component({
  selector: 'lib-action-bar',
  templateUrl: './action-bar.component.html',
  styleUrls: ['./action-bar.component.css']
})
export class ActionBarComponent extends UnsubscribeOnDestroyAdapter implements OnInit, OnChanges {

  @Input() componentes: IAtividadeComponenteDAL[];
  @Input() enTheme = EnTheme.default;
  @Input() tarefaNo: number;
  @Input() formErrors: any[];
  @Input() msgs: IMessage[] = []; // Preencha essa variável para que seja exibido uma div no rodapé.
  @Input() activityType: EnActivityType;
  @Input() saveInList: boolean;
  @Input() addToHistory = true;
  @Input() formGroup: FormGroup;
  @Input() isMobile: boolean;
  @Input() isLoading = false;
  @Input() isEdit = false
  @Input() canShowSavedMessages: boolean;
  @Input() set atividade(v: IAtividade) {
    this._atividade = v;
    if (v) {
      this.hasConfirm = this.hasConfirmButton(this.activityType);
    }
  }

  @Input() public set saved(v: boolean) {
    this._saved = v;
    if (v) {
      this.showSaveMessage(true);
    }
  }

  @Output() eventBubble: EventEmitter<IBubble> = new EventEmitter<IBubble>();

  attachmentCount = 1;

  public _atividade: IAtividade;
  get atividade(): IAtividade {
    return this._atividade;
  }

  public disable: boolean = false

  private _hasConfirm = false;
  public get hasConfirm(): boolean {
    return (this.atividade.ShowComplete || this.isListDetail()) && !this.config.isReadOnly;
  }
  public set hasConfirm(v: boolean) {
    this._hasConfirm = v;
  }

  private _saved: boolean;
  public get saved(): boolean {
    return this._saved;
  }

  public get textConfirm(): string {
    return this.msg.BUTTON_CONFIRM;
  }

  public get hasSave(): boolean {
    return this.atividade.ShowSave && !this.isListDetail() && !this.config.isReadOnly;
  }

  public get textSave(): string {
    return this.atividade.TextSave;
  }

  public get hasSaveAndNew(): boolean {
    if (this.cnfJson.showOnlySaveButton) {
      return false;
    }
    return this.atividade.ShowSaveAndNew && !this.isListDetail() && !this.config.isReadOnly;
  }

  public get textSaveAndNew(): string {
    return this.atividade.TextSaveAndNew || this.msg.BTN_SAVE_AND_NEW;
  }

  public get hasDuplicate(): boolean {
    if (this.cnfJson.showOnlySaveButton) {
      return false;
    }
    if (this.atividade.ShowDuplicate !== null) {
      return this.atividade.ShowDuplicate;
    }
    return this.hasSaveAndNew;
  }

  public get textDuplicate(): string {
    return this.msg.BTN_DUPLICATE;
  }

  onEventBubble($event: IBubble) {
    this.eventBubble.emit($event);
  }

  constructor(
    public config: ConfigStateService,
    public cnfJson: ConfigJsonService,
    protected log: LogService,
    protected dadoDAL: DadoDAL,
    protected global: GlobalService,
    protected calc: CalculatorService,
    protected lib: LibService,
    protected nav: NavigationService,
    protected matDialog: MatDialog,
    protected msg: MsgPtBR,
    protected snackBar: MatSnackBar
  ) {
    super();
  }

  ngOnInit() {
    try {
      this.hasConfirm = this.atividade && this.atividade.ShowSave && this.isListDetail();
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'ngOnInit', error.message);
    }
  }

  changeDisable() {
    this.disable = !this.disable
  }

  clicked() {
    this.changeDisable()
  }

  /* Checa se o botão de confirmação deve ou não aparecer. */
  protected hasConfirmButton(activityType: EnActivityType): boolean {
    try {
      if (this.cnfJson.showOnlySaveButton) {
        return false;
      }

      let hasConfirm = false;
      hasConfirm = hasConfirm || [EnActivityType.ProcessActivity].includes(activityType);
      hasConfirm = hasConfirm || this.isListDetail();
      hasConfirm = hasConfirm && this.atividade.ShowSave;

      return hasConfirm;
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'hasConfirmButton', error.message);
    }

    return false;
  }

  ngOnChanges() {
    try {
      if (this.saved) {
        if (this.canShowSavedMessages)
          this.showSaveMessage(true);

        this.afterSaved();
        this.saved = false;
      }
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'ngOnChanges', error.message);
    }
  }

  /**
   * Exibe uma mensagem, que desaparece automaticamente após um tempo.
   * Também previne que a mesma mensagem seja exibida novamente, ao mesmo tempo que a outra identica.
   */
  protected showMessage(msg: IMessage, interval: number = 1500): void {
    try {
      const prevMessage = this.msgs
        .filter(f => this.global.isEqual(f.detail, msg.detail) && this.global.isEqual(f.summary, msg.summary));

      if (!prevMessage || prevMessage.length <= 0) {
        this.msgs.push(msg);

        if (this.msgs && this.msgs.length > 0) {
          this.snackBar.open(
            this.msgs.map(m => m.detail).join(' '),
            this.msgs[0].summary,
            {
              duration: interval,
              verticalPosition: 'top'
            }
          );
        }
      }
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'showMessage', error.message);
    }
  }

  /* Mensagem de tentativa de salvamento */
  protected showSaveMessage(isSuccess: boolean): void {
    try {
      if (this.canShowSavedMessages) {
        if (isSuccess) {
          this.showMessage({
            severity: EnMessageSeverity.success,
            summary: this.msg.ALERT_CONFIRMATION_TITLE,
            detail: this.msg.ALERT_ACTIVITY_SAVED
          });
        } else {
          this.showMessage({
            severity: EnMessageSeverity.error,
            summary: this.msg.ALERT_WARNING_TITLE,
            detail: this.msg.ALERT_ACTIVITY_SAVE_FAILED
          });
        }
      }
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'showSaveMessage', error.message);
    }
  }

  /** Avisa o controle que a mensagem já foi exibida, para zerar o saved. */
  protected afterSaved(): void {
    try {
      this.eventBubble.emit({
        $event: null,
        bubbleEvent: EnBubbleEvent.afterSavedMessage
      } as IBubble);
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'afterSaved', error.message);
    }
  }

  /* Identifica se a atividade atual é do tipo lista. */
  protected isListDetail(): boolean {
    try {
      return this.activityType === EnActivityType.ListDetail;
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'hasSaveInList', error.message);
    }

    return false;
  }

  /* Resgata os valores inseridos no formGroup e armazena em um novo item.  */
  protected getValueFormGroup(newItem: any): any {
    try {
      if (!newItem) {
        newItem = {
          index: -1,
          label: ''
        };
      }

      const values = this.formGroup.getRawValue();
      for (const clm in values) {
        if (clm !== 'index') {
          if (this.lib.getVariavelNoFromId(clm) !== this.config.listIdVariableNo) {
            newItem[clm] = this.lib.getGEValue(values[clm]);
          }

          if (this.lib.getVariavelNoFromId(clm) === this.config.listTitleVariableNo) {
            newItem.label = values[clm];
          }
        }
      }

      return newItem;
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'getValueFormGroup', error.message);
    }
  }

  /**
   * Botão de confirmação, que fará o historyBack, e salvará os dados apenas se o controle estiver configurado
   * para salvar os dados em Cadastro.
   * Na verdade, a AtividadeCadastro (list) está preparada para alterar o objeto gridItem, na memória,
   * que será utilizado para devolução dos dados à atividade principal, que chamou essa atividade.
   */
  onConfirm($event: any, saveInList: any): void {
    try {
      this.isLoading = true;

      const backAfterComplete = this.activityType !== EnActivityType.ListDetail;
      this.eventBubble.emit({
        $event,
        bubbleEvent: EnBubbleEvent.activityComplete,
        params: { backAfterComplete }
      } as IBubble);
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'onConfirm', error.message);
    }
  }

  /**
   * Além de salvar, cria um novo registro, com os dados em branco.
   * Nessa opção, é obrigatório a marcação de SaveInList, pois, caso contrário,
   * os dados não seriam salvos (na confirmação simples eles somente são transportados para
   * a tela anterior, onde devem ser salvos).
   */
  onSaveAndNew($event: any): void {
    try {
      this.isLoading = true;

      const ano = this.componentes[0].AtividadeNo;
      this.nav.preventAddToHistory = true;

      this.eventBubble.emit({
        $event,
        bubbleEvent: EnBubbleEvent.listSaveAndNew,
        params: { ano, saveInList: true, addToHistory: this.addToHistory }
      } as IBubble);

      this.resetTab();
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'onSaveAndNew', error.message);
    }
  }

  /**
   * Força a tab para o primeiro item.
   * Se isso não for feito, a primeira aba poder não estar selecionada,
   * e a tela fica que branco.
   */
  protected resetTab(): void {
    try {
      this.eventBubble.emit({
        bubbleEvent: EnBubbleEvent.tabChange,
        params: { tabIndex: 0 }
      } as IBubble);
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'resetTab', error.message);
    }
  }

  /* Similar ao Salvar e novo, no entanto, copia os dados da atividade atual para a próxima, exceto index. */
  onDuplicate($event: any): void {
    try {
      this.isLoading = true;
      // New
      const ano = this.componentes[0].AtividadeNo;
      const newItem = this.getValueFormGroup(null);

      this.config.setDefaultFormControls(ano, newItem);
      this.nav.preventAddToHistory = true;

      this.eventBubble.emit({
        $event,
        bubbleEvent: EnBubbleEvent.listDuplicate,
        params: { ano, saveInList: true, addToHistory: this.addToHistory }
      } as IBubble);

      this.resetTab();
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'onDuplicate', error.message);
    }
  }

  /**
   * Exibe mensagem de confirmação e, se confirmado, exclui o item do Cadastro permanentemente.
   */
  onDelete($event: any): void {
    try {
      this.isLoading = true;

      const message = {
        firstButtonLabel: 'Não',
        title: 'Confirmação',
        icon: 'fa-times',
        text: `Você tem certeza que quer excluir esse item? Essa exclusão NÃO poderá ser desfeita!`,
        acceptFunc: () => {
          try {
            this.eventBubble.emit({
              $event,
              bubbleEvent: EnBubbleEvent.listDelete,
              params: {
                ano: this.config.ModeloAtividadeNo,
                ono: this.config.OcorrenciaNo.value,
                pno: this.atividade.ProcessoNo
              }
            } as IBubble);

            this.eventBubble.emit({
              $event,
              bubbleEvent: EnBubbleEvent.gotoErpGrip
            } as IBubble);

            this.nav.goBack();
          } catch (error) {
            this.log.Registrar(this.constructor.name, 'onDelete.acceptFunc', error.message);
          }
        }
      };

      this.onAlertDialog($event, message, true);
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'onDelete', error.message);
    }
  }

  /**
   * Emite um evento para a Atividade View para exibição de uma janela de Alerta.
   */
  protected onAlertDialog($event: any, message: any, hasConfirmButton: boolean): void {
    try {
      this.eventBubble.emit({
        $event,
        bubbleEvent: EnBubbleEvent.alertDialog,
        params: { message, hasConfirmButton }
      } as IBubble);
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'onAlertDialog', error.message);
    }
  }

  /* Clique no botão anexos. */
  onAttachment($event: any): void {
    try {
      const url = this.cnfJson.attachmentUrl(
        this.config.OcorrenciaNo.value,
        this.config.ModeloAtividadeNo,
        this.config.usuarioLogadoNo,
        '60vh'
      );

      if (this.attachmentCount >= 0) {
        this.eventBubble.emit({
          $event,
          bubbleEvent: EnBubbleEvent.openAttachments,
          params: {
            url,
            ono: this.config.OcorrenciaNo.value,
            ano: this.config.ModeloAtividadeNo,
            tno: this.config.TarefaNo,
            width: '100%',
            height: '100vh'
          }
        } as IBubble);
      }
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'onAttachment', error.message);
    }
  }

  /**
   * Verifica se o dark mode deve ser aplicado.
   */
  isDarkMode(): boolean {
    try {
      return this.enTheme === EnTheme.black;
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'isBlack', error.message);
    }

    return false;
  }
}

